import React from "react";

function EventsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      {...props}
    >
      <g id="Events" transform="translate(-363 -110.763)">
        <rect
          id="Rectangle_94"
          data-name="Rectangle 94"
          width="40"
          height="40"
          transform="translate(363 110.763)"
          fill="none"
        />
        <path
          id="Path_423"
          data-name="Path 423"
          d="M3565.333-3483.184c5.361,3.113,14.928,5.978,17.472,6.01l.316.005.15,0c2,.033,9.17-.537,17.632-6.014a1.6,1.6,0,0,0,0-2.559,52.789,52.789,0,0,0-18.1-5.5,56.649,56.649,0,0,0-17.472,5.482A1.8,1.8,0,0,0,3565.333-3483.184Z"
          transform="translate(-3200 3605)"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          id="Path_424"
          data-name="Path 424"
          d="M3570.571-3479.332s-.226,12.344,0,14.256c1.31,2.374,3.137,2.694,5.667,2.937,1.6.03,12.809.472,14.219,0,2.167.219,4.712-2.168,5.379-3.52.147-1.168,0-14.4,0-14.4"
          transform="translate(-3199.734 3604.476)"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        />
        <g
          id="Group_113"
          data-name="Group 113"
          transform="translate(397.554 126.049)"
        >
          <ellipse
            id="Ellipse_78"
            data-name="Ellipse 78"
            cx="2.617"
            cy="3.664"
            rx="2.617"
            ry="3.664"
            transform="translate(0 16.225)"
            fill="currentColor"
          />
          <line
            id="Line_20"
            data-name="Line 20"
            y2="12.562"
            transform="translate(2.617)"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  );
}

export default EventsIcon;
